<template>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-card-text class="table-wrapper">
              <v-data-table
              v-model="selectedItems" 
              :headers="columns" 
              :items="localTableData" 
              item-key="idx" 
              show-select
            :select-limit="selectLimit" 
            disable-pagination 
            hide-default-footer class="elevation-0" 
            @input="updateSelected"
            >

              </v-data-table>
            </v-card-text>
  
            <v-card-text>
              <slot name="bottom-content"></slot>
            </v-card-text>
  
            <slot name="bottom-buttons"></slot>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
    export default {
      name: "CheckboxTable",
      props: {
        title: {
          type: String,
          required: false,
          default: "List"
        },
        icon: {
          type: String,
          required: false,
          default: "mdi-assignment"
        },
        data: {
          type: Array,
          required: true,
        },
        columns: {
          type: Array,
          required: true,
        },
        selectLimit: {
          type: Number,
          required: false,
          default: 1,
        },
        preSelectedItems: {
          type: Array,
          required: false,
          default: () => [],
        },
      },
      data() {
        return {
          localTableData: [...this.data],
          selectedItems: [...this.preSelectedItems],
        };
      },
      methods: {
        updateSelected(selectedRows) {
          this.selectedItems = selectedRows;
          this.$emit('selected-items', this.selectedItems);
        },
        handleSelectedItems(selectedItems) {
        if (selectedItems && selectedItems.length > this.selectLimit) {
            this.$nextTick(() => {
            this.selectedItems = selectedItems.slice(0, this.selectLimit);
            });
            return;
        }
        this.selectedItems = selectedItems;
        },
      },
      computed: {
        isAllSelected() {
          return false;
        }
    },
    };
  </script>
  
  <style lang="scss" scoped>
      .table-wrapper {
        min-height: 100px;
        max-height: 400px;
        overflow-y: scroll;
    }
  </style>
  